import 'react';
import { BoldHeading, Card, JamImage, CardLinkText } from '@lendi-jam/atoms';
import { embedMarketingTrackingIntoURL } from '@lendi-jam/jam-link';
import { handleLinkTrackingEvent } from '@lendi-jam/tracking';
import Grid from '@lendi-ui/grid';
import ChevronRight from '@lendi-ui/icon/ChevronRight';
import { Body } from '@lendi-ui/typography';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { between } from '@lendi-ui/breakpoint';
import { color } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { pt, pb, px, py } from '@lendi-ui/spacing';
import styled from 'styled-components';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var FeaturedContentBackground = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), color('shade.50'));
var GenericFeaturedContentContainer = styled(Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: center;\n  ", "\n  ", "\n"])), pt('xxl'), pb('xxxl'));
var FeaturedContentCardContainer = styled(Grid.Unit)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: left;\n"])));
var FeaturedContentImageContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 200px;\n  position: relative;\n\n  ", "\n"])), between('sm', 'md')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    height: initial;\n    flex: 1;\n  "]))));
var FeaturedContentBody = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-top: initial;\n  ", "\n  ", "\n  ", "\n"])), color('shade.0'), color('shade.200'), px('xs'), py('md'), between('sm', 'md')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    flex: 0 0 55%;\n    height: 100%;\n  "]))));

var GenericFeaturedContent = function GenericFeaturedContent(_ref) {
  var title = _ref.title,
    items = _ref.items;
  return /*#__PURE__*/jsx(FeaturedContentBackground, {
    children: /*#__PURE__*/jsxs(GenericFeaturedContentContainer, {
      children: [title && /*#__PURE__*/jsx(BoldHeading, {
        size: "md",
        mb: "xl",
        children: title
      }), /*#__PURE__*/jsx(Grid, {
        halign: "center",
        children: items.map(function (item, index) {
          var _item$imageSharp, _item$imageSharp2, _item$imageSharp3, _item$imageSharp4;
          return /*#__PURE__*/jsx(FeaturedContentCardContainer, {
            size: {
              xs: 1,
              lg: 1 / 3
            },
            children: /*#__PURE__*/jsxs(Card, {
              href: embedMarketingTrackingIntoURL(item.link.url),
              onClick: function onClick() {
                handleLinkTrackingEvent(item.link.url);
              },
              children: [/*#__PURE__*/jsx(FeaturedContentImageContainer, {
                children: /*#__PURE__*/jsx(JamImage, {
                  alt: item.image.alt,
                  placeholder: (_item$imageSharp = item.imageSharp) === null || _item$imageSharp === void 0 ? void 0 : _item$imageSharp.base64,
                  src: (_item$imageSharp2 = item.imageSharp) === null || _item$imageSharp2 === void 0 ? void 0 : _item$imageSharp2.src,
                  srcSet: (_item$imageSharp3 = item.imageSharp) === null || _item$imageSharp3 === void 0 ? void 0 : _item$imageSharp3.srcSet,
                  sizes: (_item$imageSharp4 = item.imageSharp) === null || _item$imageSharp4 === void 0 ? void 0 : _item$imageSharp4.sizes
                })
              }), /*#__PURE__*/jsxs(FeaturedContentBody, {
                children: [/*#__PURE__*/jsx(BoldHeading, {
                  size: "sm",
                  mb: "sm",
                  children: item.title
                }), /*#__PURE__*/jsx(Body, {
                  size: "md",
                  mb: "md",
                  children: item.body
                }), item.link.text && /*#__PURE__*/jsxs(CardLinkText, {
                  color: "primary.500",
                  size: "sm",
                  children: [item.link.text, /*#__PURE__*/jsx(ChevronRight, {
                    width: "1.3em",
                    height: "1.3em"
                  })]
                })]
              })]
            })
          }, index);
        })
      })]
    })
  });
};

export { GenericFeaturedContent as default };
